import { ShieldCheck } from 'lucide-react';
import { Link } from 'react-router';
import { useTranslation } from '@/shared/i18n/use-translation';

/** The app's mark, a link home. */
export function BrandMark() {
  const { t } = useTranslation();
  return (
    <Link
      to="/"
      aria-label={t('Survival kit')}
      className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground shadow-sm"
    >
      <ShieldCheck className="size-4.5" />
    </Link>
  );
}
